document.addEventListener("DOMContentLoaded", function() {
  const initializeFera = () => {
    if (! fera.getRating) return;
    const ratingStars = document.querySelector('.pdp-rating-stars');
    const ratingStarsBg = document.querySelector('.pdp-rating-bg');
    const ratingStarsFg = document.querySelector('.pdp-rating-fg');
    const ratingStarsCount = document.querySelector('.pdp-rating-count');
    if (!ratingStars) return;
    fera.getRating().then((rating) => {
      const { average, count } = rating;
      if (count === 0) return;

      ratingStars.classList.remove('hidden');
      ratingStarsFg.style.width = `${average * 20}%`;
      ratingStarsCount.textContent = `(${count})`;
    });
  };

  const maxAttempts = 50;
  let attemptCount = 0;

  if (fera.getRating) {
    initializeFera();
  } else {
    const feraInterval = setInterval(() => {
      attemptCount++;
      if (typeof fera !== "undefined") {
        clearInterval(feraInterval);
        initializeFera();
      } else if (attemptCount >= maxAttempts) {
        clearInterval(feraInterval);
        console.error("Fera failed to load within the expected time.");
      }
    }, 100);
  }
  
  const designSlides = document.querySelectorAll('.design-slide [data-variant]');
  subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
    const variant = e.data.variant;
    designSlides.forEach((designSlide) => {
      designSlide.classList.toggle('hide', designSlide.dataset.variant != variant.id);
    });
  });


  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (e) => {
    const optionName = e.data.target.name;
    if (!optionName.includes('Frame') && !optionName.includes('Mat')) return;
    const productSection = e.data.target.closest('.product');
    if (!productSection) return;
    const mediaGallery = productSection.querySelector('media-gallery');
    if (!mediaGallery) return;
    mediaGallery.goToDesignSlide();
  });
  changeSlideIfFromPdp();
});

function changeSlideIfFromPdp() {
  if (!window.location.href.includes("?variant")) return;
  const mediaGallery = document.querySelector("media-gallery");
  mediaGallery.goToSlideIndex(1);
}

class ImageLoad extends HTMLElement {
  constructor() {
    super();
    this.loadedImages = 0;
  }

  connectedCallback() {
    this.images = this.querySelectorAll('img');
    if (!this.images.length) return;
    
    this.images.forEach(image => {
      if (image.complete) {
        this.imageLoaded();
      } else {
        image.addEventListener('load', () => this.imageLoaded());
      }
    });
  }

  imageLoaded() {
    this.loadedImages++;
    if (this.loadedImages === this.images.length) {
      this.classList.add('loaded');
    }
  }
}

if (!customElements.get('image-load')) {
  customElements.define('image-load', ImageLoad);
}
